import { render, staticRenderFns } from "./Approval.vue?vue&type=template&id=6ee99d7f&scoped=true&lang=pug&"
import script from "./scripts/Approval.js?vue&type=script&lang=js&"
export * from "./scripts/Approval.js?vue&type=script&lang=js&"
import style0 from "./Approval.vue?vue&type=style&index=0&id=6ee99d7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee99d7f",
  null
  
)

export default component.exports